import { PowerOff } from "lucide-react";

/**
 * A flag-gated route answered 404 or 409: the feature exists and this environment has it off.
 * Said plainly, with the server's reason, so nobody reads it as broken or as "no results".
 */
export function FeatureOff({ feature, reason }: { feature: string; reason?: string | null }) {
  return (
    <div className="state-box" role="status">
      <PowerOff aria-hidden="true" />
      <div>
        <div className="state-title">{feature} is switched off on this environment</div>
        {reason && <p className="muted">{reason}</p>}
        <p className="muted">An administrator turns it on in the deployment settings. Nothing is lost while it is off.</p>
      </div>
    </div>
  );
}
